import React from 'react'
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom'; 
import PageNav from '../../../shared/pageNav';



export default function Sidebar() {

  const {t} = useTranslation();

  return (
    <PageNav>
      <div className='sidebar-menu'>
        <ul>
          <li>
            <NavLink end to={'/restaurant/table-management/table/1'}>
              <i className='ti ti-brand-airtable'></i>
              <span>{t("label_table1")}</span>
            </NavLink>
          </li>
          <li>
            <NavLink end to={'/restaurant/table-management/reservations/list/1'}>
              <i className='ti ti-circle-check'></i>
              <span>{t("label_reservations")}</span>
            </NavLink>
          </li>
         
        
        </ul>
      </div>
    </PageNav>
  )
}
